"use strict";

exports.__esModule = true;
exports.default = void 0;
var _createSizePropertyCheck = _interopRequireDefault(require("./_createSizePropertyCheck.js"));
var _getLength = _interopRequireDefault(require("./_getLength.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Internal helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
var _default = exports.default = (0, _createSizePropertyCheck.default)(_getLength.default);